export default {
  methods: {
    formatSpaceUnit (measurement) {
      const defaultMeasurement = 'm2'
      return measurement || defaultMeasurement
    }
  }
}
